"use client"

import { TravelDeskTable } from "@/components/travel-desk/travel-desk-table"
import { useTravelDesk } from "@/components/travel-desk/use-travel-desk"

/**
 * Travel Desk as a dashboard panel (ArtDent 260914).
 *
 * The same board as `/travel-desk`, from the same components rather than a
 * copy — a trip must not read differently depending on which surface opened it.
 *
 * SELF-GATING, and it owns the hook rather than taking it from the dashboard:
 * unlike the needs-booking board, whose filters ride in the PAGE header and so
 * must share state with a sibling, everything this panel needs lives inside it.
 * That keeps the host dashboard's diff to one line and means a clinic without
 * the flag — or a coordinator without the grant, which is most of them — gets
 * no empty panel and no wasted request, just nothing.
 */
export function TravelDeskCard() {
  const board = useTravelDesk()

  if (!board.allowed) return null

  return (
    // The board needs a DEFINITE height: the table's internal `flex-1` scroller
    // has nothing to resolve against inside a scrolling column and would
    // collapse. Measured from the viewport rather than fixed, for the reason
    // the needs-booking wrapper beside it states — a fixed height wastes most
    // of a tall screen and truncates a laptop's. `min-h` keeps it usable when a
    // short window would otherwise squeeze it to two rows.
    <div className="flex h-[calc(100vh-19rem)] min-h-[22rem] flex-col">
      <TravelDeskTable board={board} embedded />
    </div>
  )
}
